import { Col, Flex, Row, message } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  fetchServicePartnerById,
  updateServicePartnerById,
} from "@/lib/api/resources/servicePartners";
import { useNavigate, useParams } from "react-router-dom";
import {
  ServicepartnerForm,
  ServicepartnerFormValues,
  ServicepartnerUpdateDto,
} from "./components/ServicepartnerForm";
import dayjs from "dayjs";

export const ServicepartnerEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  if (!id) return null;

  const servicePartnerQuery = useQuery({
    queryKey: ["service-partner", id],
    queryFn: () => fetchServicePartnerById(id),
    select: (servicePartner): ServicepartnerFormValues => {
      return {
        ...servicePartner,
        brandSupports: servicePartner.brandSupports.map((bs) => ({
          brand: bs.brand.id,
          support: bs.support,
        })),
        tags: servicePartner.tags.map((tag) => tag.id),
        dwProAccount: servicePartner.dwProAccount ?? null,
        openingHoursExceptionDates:
          servicePartner.openingHoursExceptionDates?.map((date) =>
            dayjs(date),
          ) || [],
      };
    },
  });

  const mutation = useMutation({
    mutationFn: (data: ServicepartnerUpdateDto) =>
      updateServicePartnerById(id, data),
    onSuccess: () => {
      message.success("Hersteller succesvol bijgewerkt");
      navigate(`/service-partners/partners/${id}`);
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bewerken van de hersteller",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <ServicepartnerForm
              loading={servicePartnerQuery.isFetching}
              initialValues={servicePartnerQuery.data}
              mutation={mutation}
              title="Hersteller bewerken"
              buttonText="Bewerken"
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
